import * as React from "react";
const SvgFiRrArrowProgress = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-arrow-progress_svg__a)">
      <path
        fill="#062147"
        d="M5 20a2.5 2.5 0 1 1-5 .001 2.5 2.5 0 0 1 5 0M21.5 6.5a2.5 2.5 0 1 0 0-4.999 2.5 2.5 0 0 0 0 5m-1 8v.5a1 1 0 0 0 2 0v-.5c0-2.48-2.019-4.5-4.5-4.5H4.5A2.503 2.503 0 0 1 2 7.5C2 6.122 3.122 5 4.5 5h9.728l-1.293 1.293a.999.999 0 1 0 1.414 1.414l1.972-1.972a2.41 2.41 0 0 0 0-3.405L14.284.293a.999.999 0 1 0-1.414 1.414L14.163 3H4.5A4.505 4.505 0 0 0 0 7.5C0 9.981 2.019 12 4.5 12H18c1.378 0 2.5 1.122 2.5 2.5m1 3a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5m-7.216-1.207a.999.999 0 1 0-1.414 1.414L14.163 19H8a1 1 0 0 0 0 2h6.228l-1.293 1.293a.999.999 0 1 0 1.414 1.414l1.972-1.972a2.41 2.41 0 0 0 0-3.405z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-arrow-progress_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrArrowProgress;
